import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private permissionsService: PermissionsService, private authService: AuthService) {}

  canActivate(): boolean {
    
    if (typeof window !== 'undefined' && window.localStorage) {
      const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
      if (!isLoggedIn) {
        this.router.navigate(['/login']);
        return false;
      }
    } else {
      this.router.navigate(['/login']);
      return false;
    }

    const keys = Object.keys(sessionStorage);
    keys.forEach((key) => {
      const value = sessionStorage.getItem(key);
      if (value !== null) {
        try {
          const parsedValue = JSON.parse(value);
          if (parsedValue && parsedValue.authorityType === 'MSSTS') {
            const email = parsedValue.username;
  
            this.permissionsService.getAllUserPermissions().subscribe((response) => {
              const users = response.result[0];
              const matchedUser = users.find(
                (user: any) => user.Email.toLowerCase() === email.toLowerCase()
              );
  
              if (matchedUser && matchedUser.Permissions) {
                const permissions = matchedUser.Permissions.split(',').map((p: string) => p.trim());
                this.authService.setUserPermissions(permissions);
              }
            });
            
          }
        } catch (e) {}
      }
    });
  
    return true;
  } 
}
